import { useEffect, useState } from 'react';
import apis from '@src/apis';
import { STEPS, OTHER_REASON_KEY, MAX_TEXT_LENGTH } from '../constants';

const useCancelAutoRenewDialog = () => {
  const [currentStep, setCurrentStep] = useState(STEPS.REASON_SELECTION);
  const [selectedReason, setSelectedReason] = useState('');
  const [otherReasonText, setOtherReasonText] = useState('');
  const [usageStats, setUsageStats] = useState(null);
  const [feedbackText, setFeedbackText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchStats = async () => {
      const data = await apis.subscription.getUsageStats();
      if (data?.status === 1) {
        setUsageStats(data.result || {});
      } else {
        setUsageStats({});
      }
    };
    fetchStats();
  }, []);

  const isOtherSelected = selectedReason === OTHER_REASON_KEY;

  const canProceedStep1 =
    selectedReason !== '' &&
    (!isOtherSelected || otherReasonText.trim().length > 0);

  const selectReason = (key) => {
    setSelectedReason(key);
    if (key !== OTHER_REASON_KEY) {
      setOtherReasonText('');
    }
  };

  const handleOtherTextChange = (value) => {
    setOtherReasonText(value.slice(0, MAX_TEXT_LENGTH));
  };

  const handleFeedbackChange = (value) => {
    setFeedbackText(value.slice(0, MAX_TEXT_LENGTH));
  };

  const goToNextStep = () => {
    setCurrentStep((prev) => Math.min(prev + 1, STEPS.CONFIRM_CANCELLATION));
  };

  const reset = () => {
    setCurrentStep(STEPS.REASON_SELECTION);
    setSelectedReason('');
    setOtherReasonText('');
    setUsageStats(null);
    setFeedbackText('');
    setIsSubmitting(false);
  };

  return {
    currentStep,
    selectedReason,
    otherReasonText,
    isOtherSelected,
    canProceedStep1,
    selectReason,
    handleOtherTextChange,
    usageStats,
    feedbackText,
    isSubmitting,
    handleFeedbackChange,
    setIsSubmitting,
    goToNextStep,
    reset,
  };
};

export default useCancelAutoRenewDialog;
